export const initialState = { email: '' };

export default function user(state = initialState) {
  return state;
}
